<template>
	<div id="box">
		<div id="show"><a href="#">Gorho</a></div>
		<ul id="menu">
			<li><a href="#">选项一</a></li>
			<li><a href="#">选项二</a></li>
			<li><a href="#">选项三</a></li>
		</ul>
		<div>
			<button @mouseout="abcde" @mouseover="abcdfe">
				sfgdsgsdgdfgs
			</button>
			<ul id="isShow" @mouseenter="abc" @mouseleave="abcd">
				<li><a href="#">选项一</a></li>
				<li><a href="#">选项二</a></li>
				<li><a href="#">选项三</a></li>
			</ul>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			item: {},
			navIndex: 1,
			navList: [
				{ id: 1, title: '首页', name: 'home' },
				{ id: 2, title: '公司动态', name: 'news' },
				{ id: 3, title: '日语GO', name: 'product' },
				{ id: 6, title: '德语GO', name: 'product' },
				{ id: 4, title: '日语高考', name: 'gaokao' },
				{ id: 5, title: '联系我们', name: 'contact' },
			],
		}
	},
	created() {
		console.log(this.navIndex)
		if (sessionStorage.navIndex) {
			this.navIndex = sessionStorage.navIndex
		}
		// this.abcd()
	},
	methods: {
		goHome() {
			this.navIndex = 1
			sessionStorage.navIndex = 1
			this.$router.push({ name: 'home' })
		},
		select(item) {
			if (item.name == 'product') {
				if (item.title == '日语GO') {
					window.open('https://api.juquedu.com/website/index.html')
				} else {
					window.open('https://german.juquedu.com/website/index.html')
				}
				this.navIndex = 1
				sessionStorage.navIndex = 1
			} else {
				this.navIndex = item.id
				sessionStorage.navIndex = this.navIndex
				this.$router.push({ name: item.name })
			}
		},
		// abc() {
		// 	let isShow = document.getElementById('isShow')
		// 	isShow.style.display = 'block'
		// 	this.isShow == true
		// 	console.log('悬停子菜单')
		// },
		// abcd() {
		// 	let isShow = document.getElementById('isShow')
		// 	isShow.style.display = 'none'
		// 	this.isShow == false
		// 	console.log('离开子菜单')
		// },
		// abcde() {
		// 	console.log(111)
		// 	let isShow = document.getElementById('isShow')
		// 	//获取菜单栏的坐标值
		// 	let menux = isShow.offsetLeft
		// 	// let menuy = isShow.offsetTop
		// 	let menuX = isShow.offsetLeft + isShow.offsetWidth
		// 	let menuY = isShow.offsetTop + isShow.offsetHeight

		// 	//获取鼠标的坐标值
		// 	let event = window.event
		// 	let mouseX = event.clientX
		// 	let mouseY = event.clientY

		// 	if (
		// 		mouseX < menux ||
		// 		mouseX > menuX ||
		// 		mouseY < menuY ||
		// 		mouseY > menuY
		// 	) {
		// 		isShow.style.display = 'none'
		// 	}
		// 	console.log('离开')
		// },
		// abcdfe() {
		// 	//改变菜单的内联样式display为block
		// 	let isShow = document.getElementById('isShow')
		// 	isShow.style.display = 'block'
		// 	console.log('悬停')
		// },
	},
}
window.onload = function() {
	//获取需要悬浮的对象
	let show = document.getElementById('show')
	//获取被隐藏的菜单
	let menu = document.getElementById('menu')

	//给show添加鼠标悬浮事件
	show.onmouseover = function() {
		//改变菜单的内联样式display为block
		menu.style.display = 'block'
	}

	//
	show.onmouseout = function() {
		//获取菜单栏的坐标值
		let menux = menu.offsetLeft
		// let menuy = menu.offsetTop
		let menuX = menu.offsetLeft + menu.offsetWidth
		let menuY = menu.offsetTop + menu.offsetHeight

		//获取鼠标的坐标值
		let event = window.event
		let mouseX = event.clientX
		let mouseY = event.clientY

		if (
			mouseX < menux ||
			mouseX > menuX ||
			mouseY < menuY ||
			mouseY > menuY
		) {
			menu.style.display = 'none'
		}
	}

	//分别给menu对象绑定鼠标悬浮和鼠标离开事件
	menu.onmouseover = function() {
		menu.style.display = 'block'
	}
	menu.onmouseleave = function() {
		menu.style.display = 'none'
	}
}
</script>
<style>
* {
	margin: 0;
	padding: 0;
}
li {
	list-style: none;
}
#show {
	margin-top: 10px;
	margin-left: 10px;
	width: 50px;
	height: 30px;
	border: 1px solid #ccc;
	background-color: pink;
}
#menu {
	display: none;
	margin-left: 10px;
	width: 50px;
	border: 1px solid #ccc;
	background: rgba(0, 0, 0, 0.6);
}
#menu a {
	color: #fff;
	text-decoration: none;
}
</style>
